import apiClient from '@/clients/apiClient';

export const getPayoutRequests = ({
  page = 1,
  perPage = 20,
  userId,
  businessId,
  walletId,
} = {}) => {
  const params = { page, perPage };

  if (userId != null) params.userId = userId;
  if (businessId != null) params.businessId = businessId;
  if (walletId != null) params.walletId = walletId;

  return apiClient.get('payout-requests', { params });
};

export const approvePayoutRequest = (id, payload) =>
  apiClient.post(`payout-requests/${id}/approve`, payload);

export const declinePayoutRequest = (id, payload) =>
  apiClient.post(`payout-requests/${id}/decline`, payload);

export const retryPayoutRequest = (id) =>
  apiClient.post(`payout-requests/${id}/retry`);

export const requeryPayoutRequest = (id) =>
  apiClient.post(`payout-requests/${id}/requery`);

export const getPayoutRequestStats = ({ StartAt, EndAt } = {}) => {
  const params = {};

  if (StartAt) params.StartAt = StartAt;
  if (EndAt) params.EndAt = EndAt;

  return apiClient.get('payout-requests/stats', { params });
};
